/* unplugin-vue-components disabled */import { render } from "./DashboardInfoCard.vue?vue&type=template&id=5023a830&scoped=true"
import script from "./DashboardInfoCard.vue?vue&type=script&lang=js"
export * from "./DashboardInfoCard.vue?vue&type=script&lang=js"

import "./DashboardInfoCard.vue?vue&type=style&index=0&id=5023a830&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5023a830"]])

export default __exports__